import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    // keep the same height for all elements:
    // input, input track & fake track(div)
    const height = 6;
    const inputTrack = {
        background: 'transparent',
        height
    };
    const inputThumb = {
        background: theme.palette.sliderKnob,
        border: 0,
        borderRadius: '50%',
        height: 24,
        width: 24
    };
    const focused = {
        outline: `1px solid ${theme.palette.sliderFocus}`
    };
    return {
        sliderContainer: {
            cursor: 'pointer',
            width: '100%',
            position: 'relative',
            textAlign: 'center'
        },
        knobContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 2,
            marginRight: 2,
            position: 'absolute',
            width: '100%'
        },
        knob: {
            background: theme.palette.sliderKnob,
            borderRadius: '50%',
            display: 'inline-block',
            height,
            width: 6
        },
        track: {
            background: theme.palette.sliderTrack,
            borderRadius: Number(theme.shape.borderRadius) / 2,
            height
        },
        slider: {
            // Use an additional class here to override global CSS specificity
            '&.custom-slider': {
                WebkitAppearance: 'none',
                background: 'transparent',
                height,
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                '&.focus-visible': {
                    // override global styles in order to use our own color
                    outline: 'none !important',
                    '&::-webkit-slider-runnable-track': focused,
                    '&::ms-track': focused,
                    '&::-moz-range-track': focused
                },
                '&::-webkit-slider-runnable-track': {
                    WebkitAppearance: 'none',
                    ...inputTrack
                },
                '&::-webkit-slider-thumb': {
                    WebkitAppearance: 'none',
                    position: 'relative',
                    top: -6,
                    ...inputThumb
                },
                '&::ms-track': {
                    ...inputTrack
                },
                '&::-ms-thumb': {
                    ...inputThumb
                },
                '&::-moz-range-track': {
                    ...inputTrack
                },
                '&::-moz-range-thumb': {
                    ...inputThumb
                }
            }
        }
    };
});
/**
 *  Custom slider.
 *
 *  @returns {JSX.Element}
 */
function Slider({ ariaLabel, ariaValuetext, max, min, onChange, step, value }) {
    const { classes, cx } = useStyles();
    const knobs = [...Array(Math.floor((max - min) / step) + 1)];
    return (React.createElement("div", { className: classes.sliderContainer },
        React.createElement("ul", { "aria-hidden": true, className: cx('empty-list', classes.knobContainer) }, knobs.map((_, i) => (React.createElement("li", { className: classes.knob, key: `knob-${i}` })))),
        React.createElement("div", { className: classes.track }),
        React.createElement("input", { "aria-label": ariaLabel, "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value, "aria-valuetext": ariaValuetext, className: cx(classes.slider, 'custom-slider'), max: max, min: min, onChange: onChange, step: step, type: 'range', value: value })));
}
export default Slider;
